// ─── SOCIAL CHANNELS ────────────────────────────────────────────────────────
// Pipeline-only token/temp maps and behavior flags removed.

export const SOCIAL_CHANNELS = [
  { id: 'instagram', name: 'Instagram', color: '#E4405F',
    maxChars: 2200, hashtagPolicy: '20-30 hashtag (nel primo commento)', emojiPolicy: 'Frequente e naturale',
    description: 'Caption visuale per Instagram — emozionale, hashtag strategy, CTA engagement' },
  { id: 'facebook', name: 'Facebook', color: '#1877F2',
    maxChars: 2000, hashtagPolicy: '0-2 hashtag', emojiPolicy: 'Naturale e caldo',
    description: 'Post conversazionale per feed Facebook — storytelling, community, condivisibilità' },
  { id: 'pinterest', name: 'Pinterest', color: '#E60023',
    maxChars: 500, hashtagPolicy: '2-5 hashtag', emojiPolicy: 'Minimo',
    description: 'Pin description ottimizzata SEO — keyword-rich, ispirazionale, click-through' },
  { id: 'youtube', name: 'YouTube', color: '#FF0000',
    maxChars: 5000, hashtagPolicy: '3-5 hashtag + tag dedicati', emojiPolicy: 'Moderato, nei punti chiave',
    description: 'Titolo SEO + descrizione + tag + capitoli per video YouTube' },
];

// ─── EMAIL CHANNELS ──────────────────────────────────────────────────────────

export const EMAIL_CHANNELS = [
  {
    id: 'email-classic',
    name: 'Email',
    color: '#EC4899',
    iconId: 'mail',
    description: 'Newsletter email classica: subject line + corpo + CTA',
  },
  {
    id: 'linkedin-newsletter',
    name: 'LinkedIn',
    color: '#0A66C2',
    iconId: 'book-open',
    description: 'Articolo LinkedIn Newsletter: titolo + sezioni H2 + companion post',
  },
];

